<template>
  <div class="nav-box">
    <div class="nav-left">
      <router-link to="/" :class="['button', navIndex == 0 ? 'active' : '']">首页</router-link>
      <router-link to="/case" :class="['button', navIndex == 1 ? 'active' : '']">案例</router-link>
      <router-link to="/about" :class="['button', navIndex == 2 ? 'active' : '']">关于我们</router-link>
    </div>
    <div class="nav-logo">
      <img src="@/assets/logo.png" alt="logo" />
    </div>
    <div class="nav-right">
      <router-link to="/memberintroduce" :class="['button', navIndex == 3 ? 'active' : '']">会员中心</router-link>
<!--      <router-link to="/operaterule" :class="['button', navIndex == 4 ? 'active' : '']">运营规则</router-link>-->
      <template v-if="!userInfo || (userInfo && userInfo.id_public_user_info === 92)">
        <router-link to="/login" class="button">登录</router-link>
        <router-link to="/register" class="button btn btn-red btn-reg">注册</router-link>
      </template>
      <template v-else>
        <el-dropdown placement="bottom-start">
          <div class="dropdown-user">
            <img class="avatar" :src="avatar" alt="avatar" />
            <span class="user-name">{{ showAccount }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu class="person-dropdownmenu" slot="dropdown">
            <el-dropdown-item><span @click.stop="handleCenter">个人中心</span></el-dropdown-item>
            <el-dropdown-item><span @click.stop="handleToolCenter">开发中心</span></el-dropdown-item>
            <el-dropdown-item><span @click.stop="handleLogout">退出登录</span></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </div>
  </div>
</template>
<script>
import storage from "@/utils/customLocalStorage";
import { hidePanCard } from "@/utils/tool"
import pageCommon from "@/utils/pagecommon";
import accountApi from "@/api/account";
export default {
  name: "Nav",
  data() {
    return {
      loginUser: null
    }
  },
  computed: {
    navIndex: function () {
      let _this = this;
      let idx = _this.$store.state.navIndex;
      return idx;
    },
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      if (_this.loginUser && user) {
        if ((_this.loginUser.id_public_user_info !== user.id_public_user_info) && _this.loginUser.id_public_user_info === 92) {
          return _this.loginUser
        } else {
          return user;
        }
      } else {
        return user
      }
    },
    avatar: function () {
      let _this = this;
      if (_this.userInfo && _this.userInfo.weichat_img) {
        return _this.userInfo.weichat_img;
      }
      return require("@/assets/default-avatar.png");
    },
    showAccount: function () {
      let _this = this;
      if (!_this.userInfo) {
        return "";
      }
      if (_this.userInfo.user_phone) {
        return hidePanCard(_this.userInfo.user_phone);
      }
      if (_this.userInfo.nick_name) {
        return _this.userInfo.nick_name;
      }
      return ""
    }
  },
  created() {
    this.getUserInfo()
  },
  mounted() {
  
  },
  methods: {
    getUserInfo: function () {
      let _this = this;
      pageCommon
        .apiRequestCommon(accountApi, "getUserShopInfo", {
          isloading: true,
        })
        .then(
          (res) => {
            _this.loginUser = res.public_user_info;
            storage.set("user", JSON.stringify(res.public_user_info));
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
        );
    },
    handleCenter: function () {
      let _this = this;
      _this.$router.push('/center')
    },
    handleToolCenter: function () {
      let url = window.location.origin + '/101_system_api_duzikai/dist/index.html#/warehouse'
      window.open(url)
    },
    handleLogout: function () {
      let _this = this;
      storage.set("user", null);
      storage.set("token", "");
      _this.$store.dispatch("acUser", null);
      _this.$store.dispatch("acToken", "");
      _this.$router.push("/");
    },
  },
};
</script>
<style scoped lang="less">
.nav-box {
  position: fixed;
  width: 100%;
  min-width: 1200px;
  height: 80px;
  top: 0;
  left: 0;
  background: #FFFFFF;
  // box-shadow: 0px 3px 35px 0px rgba(188, 188, 174, 0.16);

  box-shadow: 0px 3px 35px 0px rgba(207,210,215,0.16);
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #222222;
  padding: 0 68px;
  box-sizing: border-box;
  overflow: hidden;
  font-family: "Source Han Sans CN";
  z-index: 99;

  .nav-left,
  .nav-right {
    display: flex;
    align-items: center;
    .button {
      font-size: 16px;
      line-height: 20px;
      font-family: "Source Han Sans CN";
      font-weight: 600;
      text-decoration: none;
      color: #222222;
      &.active {
        color: #2C6CE6;
      }
      &:hover {
        color: #2C6CE6;
      }
    }
    .dropdown-user {
      display: flex;
      align-items: center;
      color: #222222;
      box-sizing: border-box;
      font-family: "Source Han Sans CN";
      cursor: pointer;
      .avatar {
        width: 40px;
        height: 40px;
        background: #ffffff;
        border-radius: 50%;
      }
      .user-name {
        font-size: 12px;
        font-family: "SourceHanSansCN";
        color: #222222;
        margin-left: 8px;
        margin-right: 8px;
      }
    }
  }
  .nav-left {
    .button {
      margin-right: 80px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .nav-right {
    .button {
      margin-right: 80px;
      &:first-child {
        margin-left: 0;
      }
    }
    .btn-reg {
      width: 94px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-right: 0;
      background-color: #2C6CE6;
      color: #FFFFFF;
      &.active {
        color: #ffffff;
      }
      &:hover {
        color: #ffffff;
      }
    }
  }
  .nav-logo {
    position: absolute;
    //width: 131px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    font-size: 24px;
    img {
      display: block;
      width: 131px;
      height: 100%;
      margin-right: 16px;
    }
  }
}
.person-dropdownmenu {
  width: 136px;
  padding: 0;
  /deep/.popper__arrow {
    border: none !important;
    &::after {
      border: none !important;
    }
  }
  .el-dropdown-menu__item {
    height: 46px;
    line-height: 46px;
    font-size: 14px;
    font-family: "SourceHanSansCN";
    color: rgb(34, 34, 34);
    background: #ffffff;
    text-align: center;
    padding: 0;
    span {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: rgb(255, 243, 243);

    color: rgb(236, 64, 64);
  }
}
</style>
